// extracted by mini-css-extract-plugin
export default {"label":"HSVEGYXmruP2tFkL120g","inputs-wrapper":"oE_UP2RFXDTFpN2yGWDG"};